<template>
    <headerIndex></headerIndex>
    <div class="error-content-wrapper">
        <div class="error-content">
            <h1 class="error-title">The Page is No Found! 404</h1>
            <p class="error-message" v-if="error?.statusMessage">{{ error.statusMessage }}</p>
            <nuxt-link to="/" class="home-button">Go Home</nuxt-link>
        </div>
    </div>
    <footerIndex></footerIndex>
</template>

<script setup lang="ts" name="Error404">
    import headerIndex from '~/views/leaflypackaging-com/components/header/header-index.vue'
    import footerIndex from '~/views/leaflypackaging-com/components/footer/footer-index.vue'

    const props = withDefaults(defineProps<{
      error?: any
    }>(), {
      error: () => ({})
    })

    const event = useRequestEvent()
    if (event) setResponseStatus(event, 404)
</script>
<style scoped lang="scss">
    .error-content-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 2rem 1rem;
    }

    .error-content {
        text-align: center;
        max-width: 600px;
    }

    .error-title {
        font-size: 2.5rem;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 1rem;
        
        @media (max-width: 640px) {
            font-size: 2rem;
        }
    }

    .error-message {
        font-size: 1rem;
        color: #6b7280;
        margin-bottom: 0.5rem;
    }

    .home-button {
        display: inline-block;
        margin-top: 2rem;
        padding: 0.75rem 2rem;
        background-color: #16a34a;
        color: white;
        text-decoration: none;
        border-radius: 0.5rem;
        font-weight: 600;
        font-size: 1rem;
        transition: all 0.2s ease;
        border: none;
        cursor: pointer;

        &:hover {
            background-color: #15803d;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
        }

        &:active {
            transform: translateY(0);
            box-shadow: 0 2px 6px rgba(22, 163, 74, 0.2);
        }
    }
</style>
